import type { Query } from '@rover/utilities/query';

export type SkillsAndBehaviorSlugsDictionary = {
  skillsSlugs: string[];
  behaviorsSlugs: string[];
};

type SkillsAndBehaviorParamDictionary = {
  skills: string;
  behaviors: string;
};

export const parseToArray = (value: unknown): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  return String(value).split(',').filter(Boolean);
};

export const encodeSkillAndBehaviorQueryParams = ({
  skillsSlugs,
  behaviorsSlugs,
}: SkillsAndBehaviorSlugsDictionary): SkillsAndBehaviorParamDictionary => {
  const skills = skillsSlugs.join(',');
  const behaviors = behaviorsSlugs.join(',');
  return { skills, behaviors };
};

export const decodeSkillAndBehaviorQueryParams = (
  paramString: string
): SkillsAndBehaviorSlugsDictionary => {
  const params = new URLSearchParams(paramString);
  const skills = params.get('skills');
  const behaviors = params.get('behaviors');
  const skillsSlugs = skills ? skills.split(',') : [];
  const behaviorsSlugs = behaviors ? behaviors.split(',') : [];
  return { skillsSlugs, behaviorsSlugs };
};

export const decodeSkillAndBehaviorFromQuery = (query: Query): SkillsAndBehaviorSlugsDictionary => {
  const skillsSlugs = parseToArray(query.skills);
  const behaviorsSlugs = parseToArray(query.behaviors);

  return { skillsSlugs, behaviorsSlugs };
};
